<script lang="ts">
	import { Loading } from 'carbon-components-svelte'
	import { _ } from 'svelte-i18n'
</script>

<Loading {...$$restProps} class="center" withOverlay={false} description={$_('common.loading')} />
